import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IitDesignRoutingModule } from './iit-design-routing.module';
import { IitDesignComponent } from './iit-design.component';
import { ChildComponentsModule } from "../components/child-components.module";
import { ComponentsModule } from "../components/components.module";
import { SwiperModule } from 'swiper/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonChildComponentsModule } from '../components/common-components.module'
import { CourseCardHomeComponent } from '../components/course-card-home/course-card-home.component';

@NgModule({
  declarations: [
    IitDesignComponent
  ],
  imports: [
    CommonModule,
    IitDesignRoutingModule,
    ChildComponentsModule,
    CommonChildComponentsModule,
    ComponentsModule,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    CourseCardHomeComponent
]
})
export class IitDesignModule { }
